import { render, staticRenderFns } from "./CasePublicLiability.vue?vue&type=template&id=027f3548"
import script from "./CasePublicLiability.vue?vue&type=script&lang=js"
export * from "./CasePublicLiability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports